module.exports = __webpack_public_path__ + "img/banner-5.2e8f7997.png";